import { useFlowRunStore } from '../store'

export const ResponseCounter = () => {
  const totalResponseCount = useFlowRunStore((state) => state.totalResponseCount)
  if (totalResponseCount === 0) return null

  return (
    <span className="font-inter text-xs-400 text-secondary">
      Responses: <span className="font-jetbrains tabular-nums">{totalResponseCount}</span>
    </span>
  )
}
